import { createContext } from 'react';
import { ProductEnvironment } from '@atlassian/forge-ui-types';
export var EnvironmentContext = /*#__PURE__*/createContext(ProductEnvironment.PRODUCTION);